module.exports = __webpack_public_path__ + "static/media/D725CameronMadisonAlexanderBlvdNW_2018-07-09_196.eb3e9c0d.jpg";